import {Plugin, PluginKey} from "prosemirror-state";

export const fixOrderedListOrderPlugin = new Plugin({
  key: new PluginKey('fixOrderedListOrderPlugin'),
  appendTransaction(transactions, oldState, newState) {
    let tr = newState.tr;
    let changed = false;

    newState.doc.descendants((node, pos) => {
      if (node.type.name === 'ordered_list') {
        const order = node.attrs["order"];
        if (order == null || Number.isNaN(order)) {
          tr = tr.setNodeMarkup(pos, undefined, {
            ...node.attrs,
            order: 1
          });
          changed = true;
        }
      }
    });

    return changed ? tr : null;
  }
});
